module.exports = __webpack_public_path__ + "img/1577765526.99ac38b5.jpg";